import { render, staticRenderFns } from "./cost-exclusion-scenario-step.vue?vue&type=template&id=adfce3ea&scoped=true"
import script from "./cost-exclusion-scenario-step.vue?vue&type=script&lang=ts"
export * from "./cost-exclusion-scenario-step.vue?vue&type=script&lang=ts"
import style0 from "./cost-exclusion-scenario-step.vue?vue&type=style&index=0&id=adfce3ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfce3ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adfce3ea')) {
      api.createRecord('adfce3ea', component.options)
    } else {
      api.reload('adfce3ea', component.options)
    }
    module.hot.accept("./cost-exclusion-scenario-step.vue?vue&type=template&id=adfce3ea&scoped=true", function () {
      api.rerender('adfce3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/scenario/steps/cost-exclusion-scenario-step.vue"
export default component.exports